import { useState, useEffect } from "react";
import type { ScrollState, ScrollThresholdOptions } from "@/types/navbar";

export const useScrollThreshold = ({
  initialThreshold,
  defaultScrolled = false,
}: ScrollThresholdOptions): ScrollState => {
  const [state, setState] = useState<ScrollState>({
    isScrolled: defaultScrolled,
    scrollThreshold: initialThreshold,
  });

  const updateThreshold = () => {
    const newThreshold = window.innerWidth >= 768 ? 380 : 210;
    setState((prev) => ({ ...prev, scrollThreshold: newThreshold }));
  };

  useEffect(() => {
    const handleScroll = () => {
      setState((prev) => ({
        ...prev,
        isScrolled: defaultScrolled || window.scrollY > state.scrollThreshold,
      }));
    };

    updateThreshold();
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", updateThreshold);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", updateThreshold);
    };
  }, [state.scrollThreshold, defaultScrolled]);

  return state;
};
